import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["defaultCancel", "defaultButton", "hideToggles", "onCancel", "onSave", "expandText", "cancelText", "onExpand", "crossfade", "dataCyName"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "className"];
var __jsx = React.createElement;
// expansion panel style CheckoutCard
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Button from './button';
import { Accordion, AccordionSummary, AccordionActions } from './accordion';
export var CheckoutAccordionContext = /*#__PURE__*/React.createContext();
export function CheckoutAccordion(props) {
  var onChange = props.onChange,
    expanded = props.expanded;
  var _props$defaultCancel = props.defaultCancel,
    defaultCancel = _props$defaultCancel === void 0 ? true : _props$defaultCancel,
    _props$defaultButton = props.defaultButton,
    defaultButton = _props$defaultButton === void 0 ? true : _props$defaultButton,
    _props$hideToggles = props.hideToggles,
    hideToggles = _props$hideToggles === void 0 ? false : _props$hideToggles,
    onCancel = props.onCancel,
    onSave = props.onSave,
    expandText = props.expandText,
    cancelText = props.cancelText,
    onExpand = props.onExpand,
    _props$crossfade = props.crossfade,
    crossfade = _props$crossfade === void 0 ? false : _props$crossfade,
    _props$dataCyName = props.dataCyName,
    dataCyName = _props$dataCyName === void 0 ? 'unknown' : _props$dataCyName,
    other = _objectWithoutProperties(props, _excluded);
  var contextValue = useMemo(function () {
    return {
      defaultCancel: defaultCancel,
      defaultButton: defaultButton,
      hideToggles: hideToggles,
      onChange: onChange,
      onCancel: onCancel,
      onSave: onSave,
      expanded: expanded,
      expandText: expandText,
      cancelText: cancelText,
      onExpand: onExpand,
      crossfade: crossfade,
      dataCyName: dataCyName
    };
  }, [crossfade, dataCyName, defaultCancel, defaultButton, hideToggles, onChange, onCancel, onSave, expanded, expandText, cancelText, onExpand]);
  return __jsx(CheckoutAccordionContext.Provider, {
    value: contextValue
  }, __jsx(Accordion, other));
}
export function CheckoutAccordionSummary(props) {
  var children = props.children,
    other = _objectWithoutProperties(props, _excluded2);
  var _useContext = useContext(CheckoutAccordionContext),
    defaultCancel = _useContext.defaultCancel,
    hideToggles = _useContext.hideToggles,
    onCancel = _useContext.onCancel,
    onChange = _useContext.onChange,
    expanded = _useContext.expanded,
    _useContext$expandTex = _useContext.expandText,
    expandText = _useContext$expandTex === void 0 ? 'Change' : _useContext$expandTex,
    _useContext$cancelTex = _useContext.cancelText,
    cancelText = _useContext$cancelTex === void 0 ? 'Cancel' : _useContext$cancelTex,
    onExpand = _useContext.onExpand,
    crossfade = _useContext.crossfade,
    dataCyName = _useContext.dataCyName;
  function handleCancel(e) {
    e.stopPropagation();
    if (onCancel) {
      onCancel();
    } else if (onChange) {
      onChange();
    }
  }
  function handleExpand() {
    if (onExpand) {
      onExpand();
    }
  }
  if (crossfade) {
    return __jsx(CrossfadeSummary, _extends({
      tabIndex: -1
    }, other), __jsx("div", {
      className: "summaryHider"
    }, children), !hideToggles && defaultCancel && expanded && __jsx(CancelButton, {
      "data-cy": "expanded-cancel-".concat(dataCyName),
      "data-test": "expanded-cancel-".concat(dataCyName),
      "data-testid": "expanded-cancel-".concat(dataCyName),
      onClick: handleCancel
    }, cancelText), !hideToggles && onExpand && !expanded && __jsx(ExpandText, {
      "data-cy": "expand-text-".concat(dataCyName),
      "data-test": "expand-text-".concat(dataCyName),
      "data-testid": "expand-text-".concat(dataCyName),
      onClick: handleExpand
    }, expandText));
  }
  return __jsx(StyledAccordionSummary, _extends({
    tabIndex: -1
  }, other), children, !hideToggles && defaultCancel && expanded && __jsx(CancelButton, {
    onClick: handleCancel
  }, cancelText), !hideToggles && onExpand && !expanded && __jsx(ExpandText, {
    "data-cy": "expand-text-".concat(dataCyName),
    "data-test": "expand-text-".concat(dataCyName),
    "data-testid": "expand-text-".concat(dataCyName),
    onClick: handleExpand
  }, expandText));
}
export function CheckoutAccordionActions(props) {
  var children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    other = _objectWithoutProperties(props, _excluded3);
  var _useContext2 = useContext(CheckoutAccordionContext),
    defaultButton = _useContext2.defaultButton,
    onSave = _useContext2.onSave,
    crossfade = _useContext2.crossfade,
    expanded = _useContext2.expanded,
    dataCyName = _useContext2.dataCyName;
  function renderContents() {
    return __jsx(Grid, {
      container: true
    }, __jsx(Grid, {
      "data-cy": "expand-details-".concat(dataCyName),
      "data-test": "expand-details-".concat(dataCyName),
      "data-testid": "expand-details-".concat(dataCyName),
      item: true,
      xs: 12
    }, children), __jsx(Grid, {
      item: true,
      xs: 12
    }, defaultButton && __jsx(StyledButton, {
      width: "73px",
      height: "33px",
      onClick: onSave,
      "data-cy": "checkout-expansion-save-".concat(dataCyName),
      "data-test": "checkout-expansion-save-".concat(dataCyName),
      "data-testid": "checkout-expansion-save-".concat(dataCyName)
    }, "Save")));
  }
  if (crossfade) {
    return __jsx(CrossfadeDetails, _extends({
      className: "".concat(className, " ").concat(expanded ? 'expanded' : '')
    }, other), renderContents());
  }
  return __jsx(AccordionActions, other, renderContents());
}
CheckoutAccordion.testProps = [{
  children: [__jsx(CheckoutAccordionSummary, null, "Summary"), __jsx(CheckoutAccordionActions, null, "Details")]
}, {
  children: [__jsx(CheckoutAccordionSummary, null, "Summary"), __jsx(CheckoutAccordionActions, null, "Details")],
  expanded: true
}];
CheckoutAccordionSummary.snapshot = false;
CheckoutAccordionActions.snapshot = false;
var StyledAccordionSummary = styled(AccordionSummary).withConfig({
  displayName: "checkout-accordion__StyledAccordionSummary",
  componentId: "sc-9bk662-0"
})(["align-items:center;"]);
var CrossfadeSummary = styled(AccordionSummary).withConfig({
  displayName: "checkout-accordion__CrossfadeSummary",
  componentId: "sc-9bk662-1"
})(["margin-bottom:-36px !important;& .summaryHider{display:flex;width:100%;opacity:1;transition-property:opacity;transition-duration:300ms;}&.Mui-expanded .summaryHider{opacity:0;}&.Mui-focused{background-color:transparent !important;}"]);
var CrossfadeDetails = styled(AccordionActions).withConfig({
  displayName: "checkout-accordion__CrossfadeDetails",
  componentId: "sc-9bk662-2"
})(["opacity:0;position:relative;transition-property:opacity;transition-duration:300ms;&.expanded{opacity:1;}"]);
var CancelButton = styled.button.withConfig({
  displayName: "checkout-accordion__CancelButton",
  componentId: "sc-9bk662-3"
})(["align-items:flex-start;appearance:none;background-color:transparent;border:none;color:#848f97;cursor:pointer;display:flex;font-size:13px;font-family:", ";margin:0 0 0 auto;padding:0;user-select:none;z-index:2;"], function (_ref) {
  var _theme$customized;
  var theme = _ref.theme;
  return theme === null || theme === void 0 || (_theme$customized = theme.customized) === null || _theme$customized === void 0 || (_theme$customized = _theme$customized.fonts) === null || _theme$customized === void 0 ? void 0 : _theme$customized.primary;
});
export var ExpandText = styled(CancelButton).withConfig({
  displayName: "checkout-accordion__ExpandText",
  componentId: "sc-9bk662-4"
})(["color:#848f97;text-decoration:underline;"]);
export var StyledButton = styled(Button).withConfig({
  displayName: "checkout-accordion__StyledButton",
  componentId: "sc-9bk662-5"
})(["align-self:flex-start;"]);